const addPayerPayeeGroupsQueries = require('../../../queries/configs/PayerPayeeGroups');

module.exports = addPayerPayeeGroupsQueries(function ({ baseUrl, payerId }) {
  return ({
    baseUrl: `${baseUrl}/${payerId}/payerpayeegroups`,
  })
});
